import React, {memo, useMemo} from 'react'

import {AddressWidgetConfig} from '../types'
import {AddressDrawer} from './components/AddressDrawer'
import {AddressPoint} from './components/AddressPoint'
import {OrderDetails} from './components/OrderDetails'
import {useAddressWidget} from './hooks/useAddressWidget'
import {useSelectionDependentComponents} from './hooks/useSelectionDependentComponents'

export const AddressWidget = memo((props: AddressWidgetConfig): React.ReactElement => {
  const {handleClose, handleOpen, handleSubmit, isAddressSelected, isFinalRoutePoint, opened} = useAddressWidget(props)
  const {AddressPointDescription, headerTitle, LeadSuggest, TrailSuggest} = useSelectionDependentComponents(
    isAddressSelected,
    props,
  )

  const suggestIcons = useMemo(() => ({lead: LeadSuggest, trail: TrailSuggest}), [LeadSuggest, TrailSuggest])

  return (
    <>
      <AddressPoint onClick={handleOpen} {...suggestIcons}>
        {AddressPointDescription}
      </AddressPoint>
      <AddressDrawer
        isFinalRoutePoint={isFinalRoutePoint}
        onClose={handleClose}
        onSubmit={handleSubmit}
        opened={opened}
        title={headerTitle}
      >
        <OrderDetails isAddressSelected={isAddressSelected} suggestProps={suggestIcons} widgetId={props.widget_id} />
      </AddressDrawer>
    </>
  )
})
